import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useLang } from "../i18n";
import { Button } from "./ui/button";
import { RiseLogo } from "./RiseLogo";
import { LogOut, UserRound, ShieldPlus } from "lucide-react";

export const Nav = () => {
  const { user, logout } = useAuth();
  const { lang, setLanguage, t } = useLang();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const isEmployee = user && user.role !== "admin";
  const linkCls = (path) =>
    `hidden sm:inline-flex items-center gap-1.5 text-sm rounded-full px-3 py-1.5 transition-colors ${
      location.pathname === path ? "bg-[#EAF0EC] text-[#3F6E85]" : "text-[#6E6B65] hover:text-[#3F6E85]"
    }`;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-stone-200">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to={user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/"} className="flex items-center gap-2.5" data-testid="nav-brand">
          {user && user.role !== "admin" && user.tenant?.logo_url ? (
            <img src={user.tenant.logo_url} alt={user.tenant.name} className="h-7 object-contain" data-testid="nav-tenant-logo" />
          ) : (
            <>
              <RiseLogo width={38} height={25} />
              <span className="font-serif text-2xl font-semibold tracking-tight text-[#3F6E85]">{t("brand")}</span>
            </>
          )}
        </Link>
        <div className="flex items-center gap-2">
          {isEmployee && (
            <>
              <Link to="/protocols" className={linkCls("/protocols")} data-testid="nav-protocols">
                <ShieldPlus className="w-4 h-4" /> {t("protocols_nav")}
              </Link>
              <Link to="/profile" data-testid="nav-profile" title={t("profile_nav")}
                className={`w-9 h-9 rounded-full flex items-center justify-center font-semibold text-sm transition-transform hover:scale-105 ${location.pathname === "/profile" ? "bg-[#3F6E85] text-white" : "bg-[#EAF0EC] text-[#3F6E85]"}`}>
                {(user.name || user.email || "?").trim().charAt(0).toUpperCase()}
              </Link>
            </>
          )}
          <div className="flex rounded-full border border-stone-200 overflow-hidden text-sm">
            {["it", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-${l}`}
                onClick={() => setLanguage(l)}
                className={`px-3 py-1 transition-colors ${lang === l ? "bg-[#3F6E85] text-white" : "text-stone-500 hover:text-[#3F6E85]"}`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>
          {user && (
            <Button variant="ghost" onClick={handleLogout} data-testid="nav-logout" className="rounded-full gap-2">
              <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">{t("logout")}</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
